export default {
    getTakerVolumeData: ({takerVolumeData}) => takerVolumeData,
    getOpenInterestData: ({openInterestData}) => openInterestData,
    getIndexPriceHistoryData: ({indexPriceHistoryData}) => indexPriceHistoryData,
    getFundingRateRealTimeData: ({fundingRateRealTimeData}) => fundingRateRealTimeData,
    getFundingRateHistoryData: ({fundingRateHistoryData}) => fundingRateHistoryData,
};